
import { DataType, InverterData, InverterDataComposer, ReadWrite, RegisterTable } from '../lib/inverter.model';
import { getCountryNameFromCodeABC } from './country-code';
import { V1RealTimeConfig, V2RealTimeConfig, createFault } from './inverter.config';

export const AData: Partial<RegisterTable> = {
  SysState: {
    address: 0x0000,
    name: 'State',
    dataType: DataType.U16,
    accuracy: 1,
    description: `
    Operating status
    00: wait
    01: grid check
    02: Normal
    03: Fault
    04: Permanent Fault
    `,
    access: ReadWrite.Read,
    quantity: 1,
  },
  v_pv1: {
    address: 0x0006,
    name: 'v_pv1',
    dataType: DataType.U16,
    accuracy: 0.1,
    unit: 'V',
    description: 'PV1 voltage',
    access: ReadWrite.Read,
    quantity: 1,
  },
  c_pv1: {
    address: 0x0007,
    name: 'c_pv1',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'A',
    description: 'PV1 current',
    access: ReadWrite.Read,
    quantity: 1,
  },
  v_pv2: {
    address: 0x0008,
    name: 'v_pv2',
    dataType: DataType.U16,
    accuracy: 0.1,
    unit: 'V',
    description: 'PV2 voltage',
    access: ReadWrite.Read,
    quantity: 1,
  },
  c_pv2: {
    address: 0x0009,
    name: 'c_pv2',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'A',
    description: 'PV1 current',
    access: ReadWrite.Read,
    quantity: 1,
  },
  p_pv1: {
    address: 0x000A,
    name: 'p_pv1',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'kW',
    description: 'PV1 power',
    access: ReadWrite.Read,
    quantity: 1,
  },
  p_pv2: {
    address: 0x000A,
    name: 'p_pv2',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'kW',
    description: 'PV2 power',
    access: ReadWrite.Read,
    quantity: 1,
  },
  Frequency_Grid: {
    address: 0x000E,
    name: 'FR',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'Hz',
    description: 'Grid frequency',
    access: ReadWrite.Read,
    quantity: 1,
  },
  Voltage_Phase_R: {
    address: 0x000F,
    name: 'Voltage_Phase_R',
    dataType: DataType.U16,
    accuracy: 0.1,
    unit: 'V',
    description: 'Phase Voltage-R',
    access: ReadWrite.Read,
    quantity: 1,
  },
  Current_Output_R: {
    address: 0x0010,
    name: 'Current_Output_R',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'A',
    description: 'Current-IR',
    access: ReadWrite.Read,
    quantity: 1,
  },
  Voltage_Phase_S: {
    address: 0x0011,
    name: 'Voltage_Phase_S',
    dataType: DataType.U16,
    accuracy: 0.1,
    unit: 'V',
    description: 'Phase Voltage-S',
    access: ReadWrite.Read,
    quantity: 1,
  },
  Current_Output_S: {
    address: 0x0012,
    name: 'Current_Output_S',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'A',
    description: 'Current-IS',
    access: ReadWrite.Read,
    quantity: 1,
  },
  Voltage_Phase_T: {
    address: 0x0013,
    name: 'Voltage_Phase_T',
    dataType: DataType.U16,
    accuracy: 0.1,
    unit: 'V',
    description: 'Phase Voltage-T',
    access: ReadWrite.Read,
    quantity: 1,
  },
  Current_Output_T: {
    address: 0x0014,
    name: 'Current_Output_T',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'A',
    description: 'Current-IT',
    access: ReadWrite.Read,
    quantity: 1,
  },
  P1: {
    address: 0x000C,
    name: 'P1',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'kW',
    description: 'Total PV power',
    access: ReadWrite.Read,
    quantity: 1,
  },
  FT1: {
    address: 0x000F,
    name: 'FT1',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'V',
    description: 'Phase Voltage-A',
    access: ReadWrite.Read,
    quantity: 1,
  },
  FT2: {
    address: 0x0011,
    name: 'FT2',
    dataType: DataType.I16,
    accuracy: 0.01,
    unit: 'V',
    description: 'Phase Voltage-B',
    access: ReadWrite.Read,
    quantity: 1,
  },
  FT3: {
    address: 0x0013,
    name: 'FT3',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'V',
    description: 'Phase Voltage-C',
    access: ReadWrite.Read,
    quantity: 1,
  },
  FC1: {
    address: 0x0010,
    name: 'FC1',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'A',
    description: 'Current-IA',
    access: ReadWrite.Read,
    quantity: 1,
  },
  FC2: {
    address: 0x0012,
    name: 'FC2',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'A',
    description: 'Current-IB',
    access: ReadWrite.Read,
    quantity: 1,
  },
  FC3: {
    address: 0x0014,
    name: 'FC3',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'A',
    description: 'Current-IC',
    access: ReadWrite.Read,
    quantity: 1,
  },
  ET1: {
    address: 0x0015,
    name: 'ET1',
    dataType: DataType.U32,
    accuracy: 1,
    unit: 'kWh',
    description: 'Total PV generation',
    access: ReadWrite.Read,
    quantity: 2,
  },
  EG1: {
    address: 0x0019,
    name: 'EG1',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'kWh',
    description: 'Daily PV generation',
    access: ReadWrite.Read,
    quantity: 1,
  },
  COUNTRY: {
    address: 0x0027,
    name: 'COUNTRY',
    dataType: DataType.U16,
    description: 'Country',
    access: ReadWrite.ReadWrite,
    quantity: 1,
  },
};

export const BData: Partial<RegisterTable> = {
  SysState: {
    address: 0x0000,
    name: 'State',
    dataType: DataType.U16,
    accuracy: 1,
    description: `
    Operating status
    00: wait
    01: grid check
    02: Normal
    03: Fault
    04: Permanent Fault
    `,
    access: ReadWrite.Read,
    quantity: 1,
  },
  v_pv1: {
    address: 0x0006,
    name: 'v_pv1',
    dataType: DataType.U16,
    accuracy: 0.1,
    unit: 'V',
    description: 'PV1 voltage',
    access: ReadWrite.Read,
    quantity: 1,
  },
  c_pv1: {
    address: 0x0007,
    name: 'c_pv1',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'A',
    description: 'PV1 current',
    access: ReadWrite.Read,
    quantity: 1,
  },
  v_pv2: {
    address: 0x0008,
    name: 'v_pv2',
    dataType: DataType.U16,
    accuracy: 0.1,
    unit: 'V',
    description: 'PV2 voltage',
    access: ReadWrite.Read,
    quantity: 1,
  },
  c_pv2: {
    address: 0x0009,
    name: 'c_pv2',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'A',
    description: 'PV1 current',
    access: ReadWrite.Read,
    quantity: 1,
  },
  v_pv3: {
    address: 0x000A,
    name: 'v_pv3',
    dataType: DataType.U16,
    accuracy: 0.1,
    unit: 'V',
    description: 'PV3 voltage',
    access: ReadWrite.Read,
    quantity: 1,
  },
  c_pv3: {
    address: 0x000B,
    name: 'c_pv3',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'A',
    description: 'PV3 current',
    access: ReadWrite.Read,
    quantity: 1,
  },
  p_pv1: {
    address: 0x000C,
    name: 'p_pv1',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'kW',
    description: 'PV1 power',
    access: ReadWrite.Read,
    quantity: 1,
  },
  p_pv2: {
    address: 0x000D,
    name: 'p_pv2',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'kW',
    description: 'PV2 power',
    access: ReadWrite.Read,
    quantity: 1,
  },
  p_pv3: {
    address: 0x000E,
    name: 'p_pv3',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'kW',
    description: 'PV3 power',
    access: ReadWrite.Read,
    quantity: 1,
  },
  Frequency_Grid: {
    address: 0x0011,
    name: 'FR',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'Hz',
    description: 'Grid frequency',
    access: ReadWrite.Read,
    quantity: 1,
  },
  Voltage_Phase_R: {
    address: 0x0012,
    name: 'Voltage_Phase_R',
    dataType: DataType.U16,
    accuracy: 0.1,
    unit: 'V',
    description: 'Phase Voltage-R',
    access: ReadWrite.Read,
    quantity: 1,
  },
  Current_Output_R: {
    address: 0x0013,
    name: 'Current_Output_R',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'A',
    description: 'Current-IR',
    access: ReadWrite.Read,
    quantity: 1,
  },
  Voltage_Phase_S: {
    address: 0x0014,
    name: 'Voltage_Phase_S',
    dataType: DataType.U16,
    accuracy: 0.1,
    unit: 'V',
    description: 'Phase Voltage-S',
    access: ReadWrite.Read,
    quantity: 1,
  },
  Current_Output_S: {
    address: 0x0015,
    name: 'Current_Output_S',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'A',
    description: 'Current-IS',
    access: ReadWrite.Read,
    quantity: 1,
  },
  Voltage_Phase_T: {
    address: 0x0016,
    name: 'Voltage_Phase_T',
    dataType: DataType.U16,
    accuracy: 0.1,
    unit: 'V',
    description: 'Phase Voltage-T',
    access: ReadWrite.Read,
    quantity: 1,
  },
  Current_Output_T: {
    address: 0x0017,
    name: 'Current_Output_T',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'A',
    description: 'Current-IT',
    access: ReadWrite.Read,
    quantity: 1,
  },
  P1: {
    address: 0x000F,
    name: 'P1',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'kW',
    description: 'Active Power-P total',
    access: ReadWrite.Read,
    quantity: 1,
  },
  FT1: {
    address: 0x0012,
    name: 'FT1',
    dataType: DataType.U16,
    accuracy: 0.1,
    unit: 'V',
    description: 'Phase Voltage-A',
    access: ReadWrite.Read,
    quantity: 1,
  },
  FT2: {
    address: 0x0014,
    name: 'FT2',
    dataType: DataType.I16,
    accuracy: 0.1,
    unit: 'V',
    description: 'Phase Voltage-B',
    access: ReadWrite.Read,
    quantity: 1,
  },
  FT3: {
    address: 0x0016,
    name: 'FT3',
    dataType: DataType.U16,
    accuracy: 0.1,
    unit: 'V',
    description: 'Phase Voltage-C',
    access: ReadWrite.Read,
    quantity: 1,
  },
  FC1: {
    address: 0x0013,
    name: 'FC1',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'A',
    description: 'Current-IA',
    access: ReadWrite.Read,
    quantity: 1,
  },
  FC2: {
    address: 0x0015,
    name: 'FC2',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'A',
    description: 'Current-IB',
    access: ReadWrite.Read,
    quantity: 1,
  },
  FC3: {
    address: 0x0017,
    name: 'FC3',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'A',
    description: 'Current-IC',
    access: ReadWrite.Read,
    quantity: 1,
  },
  ET1: {
    address: 0x0018,
    name: 'ET1',
    dataType: DataType.U32,
    accuracy: 1,
    unit: 'kWh',
    description: 'Total PV generation',
    access: ReadWrite.Read,
    quantity: 2,
  },
  EG1: {
    address: 0x001C,
    name: 'EG1',
    dataType: DataType.U16,
    accuracy: 0.1,
    unit: 'kWh',
    description: 'Daily PV generation',
    access: ReadWrite.Read,
    quantity: 1,
  },
  COUNTRY: {
    address: 0x002B,
    name: 'COUNTRY',
    dataType: DataType.U16,
    description: 'Country',
    access: ReadWrite.ReadWrite,
    quantity: 1,
  },
};

export const CData: Partial<RegisterTable> = {
  SysState: {
    address: 0x0200,
    name: 'State',
    dataType: DataType.U16,
    accuracy: 1,
    description: `
    0x0000: Wait state
    0x0001: Check state (Detection state)
    0x0002: Normal state
    0x0003: EPS state (Emergency Power Supply state)
    0x0004: Fault state
    0x0005: Permanent fault state
    `,
    access: ReadWrite.Read,
    quantity: 1,
  },
  Voltage_Phase_R: {
    address: 0x0206,
    name: 'Voltage_Phase_R',
    dataType: DataType.U16,
    accuracy: 0.1,
    unit: 'V',
    description: 'Phase voltage',
    access: ReadWrite.Read,
    quantity: 1,
  },
  Current_Output_R: {
    address: 0x0207,
    name: 'Current_Output_R',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'A',
    description: 'Phase current',
    access: ReadWrite.Read,
    quantity: 1,
  },
  Frequency_Grid: {
    address: 0x020c,
    name: 'grid_frequency',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'Hz',
    description: 'Grid frequency',
    access: ReadWrite.Read,
    quantity: 1,
  },
  P5: {
    address: 0x020d,
    name: 'Power_Bat_Total',
    dataType: DataType.I16,
    accuracy: 0.01,
    unit: 'kW',
    description: 'Total battery charge and discharge power. Charge is positive and discharge is negative',
    access: ReadWrite.Read,
    quantity: 1,
  },
  BT: {
    address: 0x020e,
    name: 'Battery cell',
    dataType: DataType.U16,
    accuracy: 0.1,
    unit: 'V',
    description: 'Battery cell',
    access: ReadWrite.Read,
    quantity: 1,
  },
  BC: {
    address: 0x020f,
    name: 'Battery current',
    dataType: DataType.I16,
    accuracy: 0.01,
    unit: 'A',
    description: 'Battery current',
    access: ReadWrite.Read,
    quantity: 1,
  },
  BP: {
    address: 0x0210,
    name: 'SOC_Bat',
    dataType: DataType.U16,
    accuracy: 1,
    unit: '%',
    description: 'Soc',
    access: ReadWrite.Read,
    quantity: 1,
  },
  TB: {
    address: 0x0211,
    name: 'Battery temperature',
    dataType: DataType.I16,
    accuracy: 1,
    unit: '°C',
    description: 'Battery temperature',
    access: ReadWrite.Read,
    quantity: 1,
  },
  P2: {
    address: 0x0212,
    name: 'ActivePower_PCC_Total',
    dataType: DataType.I16,
    accuracy: 0.01,
    unit: 'kW',
    description: 'Total PCC active power. Selling electricity is positive, buying electricity is negative',
    access: ReadWrite.Read,
    quantity: 1,
  },
  P4: {
    address: 0x0213,
    name: 'ActivePower_Load_Sys',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'kW',
    description: 'System total load power',
    access: ReadWrite.Read,
    quantity: 1,
  },
  P5I: {
    address: 0x0214,
    name: 'Energy storage power (from inverter)',
    dataType: DataType.I16,
    accuracy: 0.01,
    unit: 'kW',
    description: 'Energy storage power (from inverter)',
    access: ReadWrite.Read,
    quantity: 1,
  },
  P1: {
    address: 0x0215,
    name: 'PV power generation',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'kW',
    description: 'PV power generation',
    access: ReadWrite.Read,
    quantity: 1,
  },
  EPS_V_O: {
    address: 0x0216,
    name: 'Eps output voltage',
    dataType: DataType.U16,
    accuracy: 0.1,
    unit: 'V',
    description: 'Eps output voltage',
    access: ReadWrite.Read,
    quantity: 1,
  },
  EPS_P_O: {
    address: 0x0217,
    name: 'Eps power output',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'kW',
    description: 'Eps power output',
    access: ReadWrite.Read,
    quantity: 1,
  },
  EG1: {
    address: 0x0218,
    name: 'PV_Generation_Today',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'kWh',
    description: 'PV generation today',
    access: ReadWrite.Read,
    quantity: 1,
  },
  EG2: {
    address: 0x0219,
    name: 'Energy_Selling_Today',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'kWh',
    description: 'Electricity sold on the day',
    access: ReadWrite.Read,
    quantity: 1,
  },
  EG3: {
    address: 0x021a,
    name: 'Energy_Purchase_Today',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'kWh',
    description: 'Buy electricity on the day',
    access: ReadWrite.Read,
    quantity: 1,
  },
  EG4: {
    address: 0x021b,
    name: 'Load_Consumption_Today',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'kWh',
    description: 'Load power consumption of the day',
    access: ReadWrite.Read,
    quantity: 1,
  },
  ET1: {
    address: 0x021c,
    name: 'PV_Generation_Total',
    dataType: DataType.U32,
    accuracy: 1,
    unit: 'kWh',
    description: 'Total power generation time',
    access: ReadWrite.Read,
    quantity: 2,
  },
  ET2: {
    address: 0x021e,
    name: 'Energy_Selling_Total',
    dataType: DataType.U32,
    accuracy: 1,
    unit: 'kWh',
    description: 'Total electricity sold',
    access: ReadWrite.Read,
    quantity: 2,
  },
  ET3: {
    address: 0x0220,
    name: 'Energy_Purchase_Total',
    dataType: DataType.U32,
    accuracy: 1,
    unit: 'kWh',
    description: 'Total electricity purchased',
    access: ReadWrite.Read,
    quantity: 2,
  },
  ET4: {
    address: 0x0222,
    name: 'Load_Consumption_Total',
    dataType: DataType.U32,
    accuracy: 1,
    unit: 'kWh',
    description: 'Total load power consumption',
    access: ReadWrite.Read,
    quantity: 2,
  },
  EG5: {
    address: 0x0224,
    name: 'Bat_Charge_Today',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'kWh',
    description: 'Battery charge capacity of the day',
    access: ReadWrite.Read,
    quantity: 1,
  },
  EG6: {
    address: 0x0225,
    name:'Bat_Discharge_Today',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'kWh',
    description: 'Battery discharge capacity of the day',
    access: ReadWrite.Read,
    quantity: 1,
  },
  ET5: {
    address: 0x0226,
    name: 'Bat_Charge_Total',
    dataType: DataType.U32,
    accuracy: 1,
    unit: 'kWh',
    description: 'Total battery charge capacity',
    access: ReadWrite.Read,
    quantity: 2,
  },
  ET6: {
    address: 0x0228,
    name: 'Bat_Discharge_Total',
    dataType: DataType.U32,
    accuracy: 1,
    unit: 'kWh',
    description: 'Total battery discharge capacity',
    access: ReadWrite.Read,
    quantity: 2,
  },
  COUNTDOWN: {
    address: 0x022a,
    name: 'Countdown',
    dataType: DataType.U16,
    accuracy: 1,
    unit: 's',
    description: 'Power-on countdown',
    access: ReadWrite.Read,
    quantity: 1,
  },
  I_ALARM: {
    address: 0x022b,
    name: 'inverter_alarm',
    dataType: DataType.U16,
    accuracy: 1,
    description: '',
    access: ReadWrite.Read,
    quantity: 1,
  },
  BN: {
    address: 0x022c,
    name: 'battery_cycles',
    dataType: DataType.U16,
    accuracy: 1,
    description: 'Battery cycles',
    access: ReadWrite.Read,
    quantity: 1,
  },
  busVoltage: {
    address: 0x022d,
    name: 'bus_voltage',
    dataType: DataType.U16,
    accuracy: 0.1,
    unit: 'V',
    description: 'Bus voltage',
    access: ReadWrite.Read,
    quantity: 1,
  },
  llcBusVoltage: {
    address: 0x022e,
    name: 'llc_bus_voltage',
    dataType: DataType.U16,
    accuracy: 0.1,
    unit: 'V',
    description: 'Llc bus voltage',
    access: ReadWrite.Read,
    quantity: 1,
  },
  BUCK_C: {
    address: 0x022f,
    name: 'buck_current',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'A',
    description: 'Buck current',
    access: ReadWrite.Read,
    quantity: 1,
  },
  RPhase_V: {
    address: 0x0230,
    name: 'r_phase_voltage',
    dataType: DataType.U16,
    accuracy: 0.1,
    unit: 'V',
    description: 'R phase voltage',
    access: ReadWrite.Read,
    quantity: 1,
  },
  RPhase_C: {
    address: 0x0231,
    name: 'r_phase_current',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'A',
    description: 'R phase current',
    access: ReadWrite.Read,
    quantity: 1,
  },
  SOH: {
    address: 0X0237,
    name: 'SOH',
    dataType: DataType.U16,
    accuracy: 1,
    unit: '%',
    description: 'Battery health degree',
    access: ReadWrite.Read,
    quantity: 1,
  },
  COUNTRY: {
    address: 0X023A,
    name: 'COUNTRY',
    dataType: DataType.U16,
    description: 'Country',
    access: ReadWrite.ReadWrite,
    quantity: 1,
  },
  pv1_insulation_resistance_to_ground: {
    address: 0x0246,
    name: 'pv1_insulation_resistance_to_ground',
    dataType: DataType.U16,
    accuracy: 1,
    unit: 'MΩ',
    description: 'PV1+ insulation resistance to ground',
    access: ReadWrite.Read,
    quantity: 1,
  },
  pv2_insulation_resistance_to_ground: {
    address: 0x0247,
    name: 'pv2_insulation_resistance_to_ground',
    dataType: DataType.U16,
    accuracy: 1,
    unit: 'MΩ',
    description: 'PV2+ insulation resistance to ground',
    access: ReadWrite.Read,
    quantity: 1,
  },
  pv_insulation_resistance_to_ground: {
    address: 0x0248,
    name: 'pv_insulation_resistance_to_ground',
    dataType: DataType.U16,
    accuracy: 1,
    unit: 'MΩ',
    description: 'PV- insulation resistance to ground',
    access: ReadWrite.Read,
    quantity: 1,
  },
  InputMode: {
    address: 0x0249,
    name: 'input_mode',
    dataType: DataType.U16,
    accuracy: 1,
    description: `
    0-- parallel mode
    1-- independent mode`,
    access: ReadWrite.Read,
    quantity: 1,
  },
  v_pv1: {
    address: 0x0250,
    name: 'v_pv1',
    dataType: DataType.U16,
    accuracy: 0.1,
    unit: 'V',
    description: 'PV1 voltage',
    access: ReadWrite.Read,
    quantity: 1,
  },
  c_pv1: {
    address: 0x0251,
    name: 'c_pv1',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'A',
    description: 'PV1 current',
    access: ReadWrite.Read,
    quantity: 1,
  },
  v_pv2: {
    address: 0x0253,
    name: 'v_pv2',
    dataType: DataType.U16,
    accuracy: 0.1,
    unit: 'V',
    description: 'PV2 voltage',
    access: ReadWrite.Read,
    quantity: 1,
  },
  c_pv2: {
    address: 0x0254,
    name: 'c_pv2',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'A',
    description: 'PV1 current',
    access: ReadWrite.Read,
    quantity: 1,
  },
  p_pv1: {
    address: 0x0252,
    name: 'p_pv1',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'kW',
    description: 'PV1 power',
    access: ReadWrite.Read,
    quantity: 1,
  },
  p_pv2: {
    address: 0x0255,
    name: 'p_pv2',
    dataType: DataType.U16,
    accuracy: 0.01,
    unit: 'kW',
    description: 'PV2 power',
    access: ReadWrite.Read,
    quantity: 1,
  },
};

export const AFaults: Partial<RegisterTable> = {
  Fault6: {
    address: 0x0021,
    name: 'Fault6',
    dataType: DataType.U16,
    accuracy: 1,
    description: 'Inverter alarm information',
    access: ReadWrite.Read,
    quantity: 1,
  },
  Fault7: {
    address: 0x0023,
    name: 'Fault7',
    dataType: DataType.U16,
    accuracy: 1,
    description: 'Communication board inside information',
    access: ReadWrite.Read,
    quantity: 1,
  },
};
const fault_start_A = V1RealTimeConfig.Fault.start;
const fault_index_start_A = V1RealTimeConfig.Fault.indexToStart;
for (let i = 0; i < V1RealTimeConfig.Fault.length; i++) {
  AFaults[`Fault${fault_index_start_A + i}`] = createFault(
    fault_index_start_A + i,
    fault_start_A + i,
  ).fault;
}

export const BFaults: Partial<RegisterTable> = {
  ...AFaults,
  Fault6: {
    address: 0x0025,
    name: 'Fault6',
    dataType: DataType.U16,
    accuracy: 1,
    description: 'Inverter alarm information',
    access: ReadWrite.Read,
    quantity: 1,
  },
  Fault7: {
    address: 0x0027,
    name: 'Fault7',
    dataType: DataType.U16,
    accuracy: 1,
    description: 'Communication board inside information',
    access: ReadWrite.Read,
    quantity: 1,
  },
};

export const CFaults: Partial<RegisterTable> = {
  Fault6: {
    address: 0x022B,
    name: 'Fault6',
    dataType: DataType.U16,
    accuracy: 1,
    description: 'Inverter alarm information',
    access: ReadWrite.Read,
    quantity: 1,
  },
  Fault7: {
    address: 0x0242,
    name: 'Fault7',
    dataType: DataType.U16,
    accuracy: 1,
    description: 'Communication board inside information',
    access: ReadWrite.Read,
    quantity: 1,
  },
  Fault8: {
    address: 0x023D,
    name: 'Fault7',
    dataType: DataType.U16,
    accuracy: 1,
    description: 'Lithium battery error message',
    access: ReadWrite.Read,
    quantity: 1,
  },
};
const fault_start_C = V2RealTimeConfig.Fault.start;
const fault_index_start_C = V2RealTimeConfig.Fault.indexToStart;
for (let i = 0; i < V2RealTimeConfig.Fault.length; i++) {
  CFaults[`Fault${fault_index_start_C + i}`] = createFault(
    fault_index_start_C + i,
    fault_start_C + i,
  ).fault;
}

export const ComposeCData: Partial<InverterDataComposer> = {
  P3: (data: Partial<InverterData>) => {
    if (data.P2 && typeof data.P2 === 'number' && data.P2 < 0) {
      data.P3 = data.P2 * -1;
      data.P2 = 0;
    }
    return data;
  },
  P6: (data: Partial<InverterData>) => {
    if (data.P5 && typeof data.P5 === 'number' && data.P5 < 0) {
      data.P6 = data.P5 * -1;
      data.P5 = 0;
    }
    return data;
  },
  P1: (data: Partial<InverterData>) => {
    if (
        data.P4 && typeof data.P4 === 'number' && data.P4 > 0 &&
        data.P3 && typeof data.P3 === 'number' && data.P3 === 0 &&
        data.P2 && typeof data.P2 === 'number' && data.P2 === 0 &&
        data.P1 && typeof data.P1 === 'number' && data.P5 === 0 &&
        data.P6 && typeof data.P6 === 'number' && data.P6 === 0 &&
        data.P1 && typeof data.P1 === 'number' && data.P1 === 0
      ) {
      data.P1 = data.P4;
    }
    return data;
  },
  COUNTRY: (data: Partial<InverterData>) => {
    if (data.COUNTRY && typeof data.COUNTRY === 'number') {
      data.COUNTRY = getCountryNameFromCodeABC(data.COUNTRY);
    }
    return data;
  },
};
